import { render, staticRenderFns } from "./del_history.vue?vue&type=template&id=2e989d34&scoped=true"
import script from "./del_history.vue?vue&type=script&lang=js"
export * from "./del_history.vue?vue&type=script&lang=js"
import style0 from "./del_history.vue?vue&type=style&index=0&id=2e989d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e989d34",
  null
  
)

export default component.exports